import BossModel from "@/models/BossModel";
import PublicImage from "@/models/PublicImage/PublicImage";
import Image from "@/models/WebsitePackage/Image/Image";
import Country from "@/models/Country/Country";
import Text from "./Text/Text";
import orderBy from 'lodash/orderBy';
import WebsitePackageCountry from "@/models/WebsitePackage/WebsitePackageCountry";
import Region from "@/models/Region/Region";
import WebsitePackageRegion from "@/models/WebsitePackage/WebsitePackageRegion";
import WebsiteCategory from "@/models/WebsiteCategory/WebsiteCategory";
import WebsitePackageWebsiteCategory from "@/models/WebsitePackage/WebsitePackageWebsiteCategory";

export default class WebsitePackage extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-package';

    /**
     *
     * @type {string}
     */
    static entity = 'websitePackages';

    static fields() {
		return {
			id: this.number(null).nullable(),
			website_title: this.attr(null),
			website_subtitle: this.attr(null),
			in_feeds: this.boolean(null),
			header_image_id: this.number(null).nullable(),
			featured_image_id: this.number(null).nullable(),
			package_id: this.number(null).nullable(),
            featuredImage: this.belongsTo(PublicImage, 'featured_image_id'),
            headerImage: this.belongsTo(PublicImage, 'header_image_id'),
            websitePackageImages: this.hasMany(Image, 'website_package_id'),
            countries: this.belongsToMany(Country, WebsitePackageCountry,'website_package_id', 'country_id'),
            regions: this.belongsToMany(Region, WebsitePackageRegion,'website_package_id', 'region_id'),
            websiteCategories: this.belongsToMany(WebsiteCategory, WebsitePackageWebsiteCategory,'website_package_id', 'website_category_id'),
            packageTexts: this.hasMany(Text, 'website_package_id'),
		}
	}

    /**
     *
     * @returns {*}
     */
    static loadAll() {
        return this.api()
            .limit(0)
            .where('is_active', true)
            .get(true);
    }

    /**
     *
     * @param websiteCategories
     * @returns {Promise<AxiosResponse<T>>}
     */
    syncWebsiteCategories(websiteCategories) {
        return this.constructor.api().beforeInsert(() => {
            this.constructor.query().with('websiteCategories').find(this.id).websiteCategories.forEach(category => {
                category.pivot.$delete();
            });
        }).action(this.id + '/sync-website-categories').update({websiteCategories: websiteCategories});
    }

    /**
     *
     * @param regions
     * @returns {Promise<AxiosResponse<T>>}
     */
    syncRegions(regions) {
        return this.constructor.api().beforeInsert(() => {
            this.constructor.query().with('regions').find(this.id).regions.forEach(region => {
                region.pivot.$delete();
            });
        }).action(this.id + '/sync-regions').update(regions);
    }

    /**
     *
     * @param countries
     * @returns {Promise<AxiosResponse<T>>}
     */
    syncCountries(countries) {
        return this.constructor.api().beforeInsert(() => {
            this.constructor.query().with('countries').find(this.id).countries.forEach(country => {
                country.pivot.$delete();
            });
        }).action(this.id + '/sync-countries').update(countries);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Countries(){
        return this.getRelated('countries');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WebsiteCategories(){
        return this.getRelated('websiteCategories');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Regions(){
        return this.getRelated('regions');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    HeaderImage(){
        return this.getRelated('headerImage');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    FeaturedImage(){
        return this.getRelated('featuredImage');
    }

    /**
     *
     * @constructor
     */
    WebsitePackageImages(){
        return orderBy(this.getRelated('websitePackageImages'), 'sort_order');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    PackageTexts(){
        return this.getRelated('packageTexts');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    ProductInformation(){
        return this.PackageTexts().find(text => text.product_information !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Inclusive(){
        return this.PackageTexts().find(text => text.inclusive !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Exclusive(){
        return this.PackageTexts().find(text => text.exclusive !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    ImportantInformation(){
        return this.PackageTexts().find(text => text.important_information !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Highlights(){
        return this.PackageTexts().find(text => text.highlights !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    CarRental() {
        return this.PackageTexts().find(text => text.car_rental !== undefined);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    AllInclusive() {
        return this.PackageTexts().find(text => text.all_inclusive !== undefined);
    }
}
